import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FormSelectRow } from "./form-select-row";
import FormModalShell from "../ui/form-modal-shell";
import { CourierActions } from "../ui/courier-fields";

const AddRoundStopForm = ({
  closeModal,
  loading,
  apiError,
  centers = [],
  createCourierRoundStop,
  roundId,
  nextSequence
}) => (
  <FormModalShell title="Add Stop" apiError={apiError} onClose={closeModal}>
      <Formik
        initialValues={{ center: "" }}
        validationSchema={Yup.object().shape({
          center: Yup.string().required("Required field")
        })}
        onSubmit={values => {
          createCourierRoundStop({
            roundId,
            data: { center: Number(values.center), sequence: nextSequence }
          });
        }}
      >
        {formik => (
          <Form>
            <FormSelectRow
              label="Center"
              name="center"
              value={formik.values.center}
              onChange={e => formik.setFieldValue("center", e.target.value)}
              error={formik.touched.center && formik.errors.center}
              required
              options={centers.map(c => ({ value: c.id, label: c.name }))}
            />
            <CourierActions
              loading={loading}
              submitLabel="Add Stop"
              onCancel={closeModal}
            />
          </Form>
        )}
      </Formik>
  </FormModalShell>
);

export default AddRoundStopForm;
